// extracted by mini-css-extract-plugin
export default {"List":"BulletPointList_List__G3XIv"};